export default __webpack_public_path__ + "static/media/check-gray.857e27c9.svg";